import { render, staticRenderFns } from "./JourneyStatisticsConfiguration.vue?vue&type=template&id=7489c2fb&scoped=true&"
import script from "./JourneyStatisticsConfiguration.vue?vue&type=script&lang=js&"
export * from "./JourneyStatisticsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./JourneyStatisticsConfiguration.vue?vue&type=style&index=0&id=7489c2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489c2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7489c2fb')) {
      api.createRecord('7489c2fb', component.options)
    } else {
      api.reload('7489c2fb', component.options)
    }
    module.hot.accept("./JourneyStatisticsConfiguration.vue?vue&type=template&id=7489c2fb&scoped=true&", function () {
      api.rerender('7489c2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/JourneyStatisticsConfiguration.vue"
export default component.exports